<template>
  <b-list-group-item>
    <div class="font-weight-bold text-primary">
      Tarih
    </div>
    <template v-if="dataModal.dataItem.ddate">
      <div>
        {{ moment(dataModal.dataItem.ddate).format('DD.MM.YYYY') }}
      </div>
    </template>
    <template v-else>
      Belirtilmedi
    </template>
  </b-list-group-item>
</template>
<script>
import { BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'DonateDate',
  components: {
    BListGroupItem,
  },
  computed: {
    dataModal() {
      return this.$store.getters['accountActivities/dataModal']
    },
  },
}
</script>
